import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
  state: () => ({
    products: [
      {
        id: 1,
        name: 'EdgePOD-R',
        shortDescription: 'Compact 1U edge-node server with AMD CPU ',
        image: require('../assets/rapidspace-EdgePOD.Front-002-en.jpg'),
        fullDescription: 'EdgePOD is ideal for 3C networks (Connected Collaborative Computing) and for rack cabinets used in factories, offices, goverment, hospitals or outdoor telecom.',
        specifications: [
          { name: 'Model', value: 'EdgePOD-R' },
          { name: 'Fortmat', value: 'ESA' },
          { name: 'CPU', value: 'AMD Ryzen 7950X3D' },
          { name: 'SSD', value: '2 TB / 4 TB' },
          { name: 'Ethernet', value: '2*10 Gbps RJ45, 2*1 Gbps RJ45' },
          { name: 'Hardware Options', value: 'CPRI / eCPRI / GPU' }
        ],
        features: ['Plug-and-play edge computing', 'Digital Resilience', 'Disaster Recovery Mesh', 'Low Latency', 'Globally Immune', 'Zere-Knowledge Security', 'Fully Open'],
        datasheet: '#'
      },
      {
        id: 2,
        name: 'Open Radio Station',
        shortDescription: 'Compact 4G/5G base station',
        image: require('../assets/RS-Image.Open.Radio.Station-001-en.png'),
        fullDescription: 'ORS speeds up deployment of 4G/5G private and public networks',
        specifications: [
          { name: 'Model', value: 'ORS' },
          { name: 'CPU', value: 'Intel i5 / Intel Atom x7425E' },
          { name: 'RAM', value: '8 GB' },
          { name: 'SSD', value: '128 GB' },
          { name: 'Power', value: '65W PoE' },
          { name: 'Network', value: '1 Gbps PoE' },
          { name: 'OS', value: 'GNU/Linux(open source)' },
          { name: 'OSS/BSS', value: 'SlapOS(open source)' },
          { name: 'Edge computing', value: 'Galene(MCPTT) + Delta Chat(Messaging) + Theia(PaaS) + Traffic Server(CDN)' },
          { name: 'vRAN stack', value: 'Amarisoft with built-in eNodeB + gNodeB + core network' },
          { name: 'Dimension', value: '170 * 102 * 240 mm' },
          { name: 'Weight', value: '2.4 kg' },
          { name: 'Certifications', value: 'EN 301 489-52 + EN 301 489-19 + EN 623680-1 + EN 60950-22 + RoHS' },
          { name: 'Radio power(mean)', value: '2 * 1 W(max)' },
          { name: 'Mode', value: 'TDD' },
          { name: 'LTE Bands(TDD)', value: 'B38, B39, B41, B42, B43, B48' },
          { name: 'NR Bands(TDD)', value: 'N38, N39, N41, N48, N77, N78, N79' },
          { name: 'Maximum bandwidth', value: '50 MHz' }
        ],
        features: ['Autonomous base station', 'Amarisoft radio software', 'Open Source', 'Self-configuration'],
        datasheet: '#'
      },
      {
        id: 3,
        name: 'ORS Max',
        shortDescription: '2 * 10W 50-100 Mhz all-in-one 4G/5G base station',
        image: require('../assets/rapidspace-Image.ORS.Max.Leaflet-001-en.jpg'),
        fullDescription: 'ORS Max provides 2 * 10 W for energy-efficient TDD 4G/5G networks powered by a single PoE cable',
        specifications: [
          { name: 'Model', value: 'ORS-Max' },
          { name: 'CPU', value: 'Intel Atom x7425E or AMD V3000 or Rockchip RK3588' },
          { name: 'RAM', value: '8 GB' },
          { name: 'SSD', value: '128 GB' },
          { name: 'Power', value: '65W PoE' },
          { name: 'Network', value: '1 Gbps PoE' },
          { name: 'OS', value: 'GNU/Linux(open source)' },
          { name: 'OSS/BSS', value: 'SlapOS(open source)' },
          { name: 'Edge computing', value: 'Galene(MCPTT) + Delta Chat(Messaging) + Theia(PaaS) + Traffic Server(CDN) + Netframe(Workspace)' },
          { name: 'vRAN stack', value: 'Amarisoft with built-in eNodeB + gNodeB + core network' },
          { name: 'Dimension', value: '221 * 135 * 321 mm' },
          { name: 'Weight', value: '4.2 kg' },
          { name: 'Certifications', value: 'EN 301 489-52 + EN 301 489-19 + EN 623680-1 + EN 60950-22 + RoHS' },
          { name: 'Mode', value: 'TDD' },
          { name: 'LTE Bands(TDD)', value: 'B40, B38/B41, B42, B43' },
          { name: 'NR Bands(TDD)', value: 'N40, N38/N41, N78, N77, N79' },
          { name: 'Radio power(mean)', value: '2 * 7 W(B40), 2 * 3W(N79), 2 * 10W(Rest)' },
          { name: 'Maximum bandwidth', value: '50 MHz(upgradable to 100 Mhz)' }
        ],
        features: ['Autonomous base station', 'Amarisoft radio software', 'Open Source', 'Self-configuration', 'Single Cable'],
        datasheet: '#'
      },
      {
        id: 4,
        name: 'ORS Duo',
        shortDescription: '4 * 1W 100 Mhz all-in-one 4G/5G mesh',
        image: require('../assets/rapidspace-Image.ORS.Duo.Leaflet-en-001.png'),
        fullDescription: 'ORS Duo 4 * 1 W is dual band, dual mode (gNb + UE) all-in-one 4G/5G base station designed for advanced applications such as tactical 5G mesh, Industry 4.0 and 5G NSA networks.',
        specifications: [
          { name: 'Model', value: 'ORS Duo' },
          { name: 'CPU', value: 'Intel Atom x7425E or AMD V3000' },
          { name: 'RAM', value: '8 GB' },
          { name: 'SSD', value: '128 GB' },
          { name: 'Power', value: '55W PoE' },
          { name: 'Network', value: '2.5 Gbps RJ45 Ethernet' },
          { name: 'OS', value: 'GNU/Linux(open source)' },
          { name: 'OSS/BSS', value: 'SlapOS(open source)' },
          { name: 'Edge computing', value: 'Galene(MCPTT) + Delta Chat(Messaging) + Theia(PaaS) + Traffic Server(CDN) + Netframe(Workspace)' },
          { name: 'vRAN stack', value: 'Amarisoft with built-in eNodeB + gNodeB + core network' },
          { name: 'Dimension', value: '221 * 135 * 321 mm' },
          { name: 'Weight', value: '4.2 kg' },
          { name: 'Certifications', value: 'EN 301 489-52 + EN 301 489-19 + EN 623680-1 + EN 60950-22 + RoHS' },
          { name: 'Radio power(mean)', value: '4 * 1 W(Max)' },
          { name: 'Mode', value: 'TDD' },
          { name: 'LTE Bands(TDD)', value: 'B28, B38, B40, B41, B42, B43' },
          { name: 'NR Bands(TDD)', value: 'N28, N40, N38, N41, N78, N77, N79' },
          { name: 'Maximum bandwidth', value: '100 Mhz)' }
        ],
        features: ['Autonomous base station', 'Amarisoft radio software', 'Open Source', 'Self-configuration', 'Single Cable'],
        datasheet: '#'
      },
      {
        id: 4,
        name: 'EdgePOD-H',
        shortDescription: 'Compact 1U edge-node server with Hygon CPU ',
        image: require('../assets/rapidspace-EdgePOD.Front-002-en.jpg'),
        fullDescription: 'EdgePOD is ideal for 3C networks (Connected Collaborative Computing) and for rack cabinets used in factories, offices, goverment, hospitals or outdoor telecom.',
        specifications: [
          { name: 'Model', value: 'EdgePOD-H' },
          { name: 'Fortmat', value: 'ESA' },
          { name: 'CPU', value: 'Hygon 3250' },
          { name: 'SSD', value: '1TB' },
          { name: 'Ethernet', value: '1*1 Gbps RJ45' },
          { name: 'Hardware Options', value: 'CPRI * eCPRI' }
        ],
        features: ['Plug-and-play edge computing', 'Digital Resilience', 'Disaster Recovery Mesh', 'Low Latency', 'Globally Immune', 'Zere-Knowledge Security', ''],
        datasheet: '#'
      },
      {
        id: 5,
        name: 'EdgePOD-N',
        shortDescription: 'Compact 1U edge-node server with NXP CPU ',
        image: require('../assets/rapidspace-EdgePOD.Front-002-en.jpg'),
        fullDescription: 'EdgePOD is ideal for 3C networks (Connected Collaborative Computing) and for rack cabinets used in factories, offices, goverment, hospitals or outdoor telecom.',
        specifications: [
          { name: 'Model', value: 'EdgePOD-N' },
          { name: 'Fortmat', value: 'ESA' },
          { name: 'CPU', value: 'NXP Layerscape LX2160A' },
          { name: 'SSD', value: '1 TB' },
          { name: 'Ethernet', value: '4* 10 Gbps SFP+, 1* 100 Gbps QSFP' },
          { name: 'Hardware Options', value: '' }
        ],
        features: ['Plug-and-play edge computing', 'Digital Resilience', 'Disaster Recovery Mesh', 'Low Latency', 'Globally Immune', 'Zere-Knowledge Security', 'Fully Open'],
        datasheet: '#'
      }
    ],
    partners: [
      {
        id: 1,
        name: 'RapdiSpace',
        logo: require('../assets/NXD-Logo.Shop.Rapid.png'),
        description: 'Leading provider of enterprise software solutions with over 15 years of industry experience.'
      },
      {
        id: 2,
        name: 'Nexed SA',
        logo: require('../assets/NXD-Media.Logo.png'),
        description: 'Europe’s largest open-source publisher (founded 2001), creator of ERP5.'
      },
      {
        id: 3,
        name: 'Amarisoft',
        logo: require('../assets/amarisoft_logo.png'),
        description: 'French software firm (2012) that pioneered 100 % software LTE/5G stacks.'
      },
      {
        id: 4,
        name: 'Prose',
        logo: require('../assets/prose_technologies_logo.jpeg'),
        description: 'PROSE Technologies is a globally connected venture specializing in advanced wireless communication solutions.'
      },
      {
        id: 5,
        name: 'NTS',
        logo: require('../assets/nts_high_tech_partner_logo.jpeg'),
        description: 'NTS is a first-tier contract manufacturer and develop, produce, assemble and tests complex (opto-)mechatronic systems and mechanical modules.'
      },
      {
        id: 6,
        name: 'MiTAC',
        logo: require('../assets/MiTAC_logo.png'),
        description: 'A global technology group that manufactures cloud computing servers, automotive electronics, and smart edge devices.'
      },
      {
        id: 7,
        name: 'ASRock',
        logo: require('../assets/ASRock_Logo.png'),
        description: 'A technology company specializing in the design and manufacture of computer motherboards, graphics cards, and compact PCs for gaming and commercial markets.'
      },
      {
        id: 8,
        name: 'SuperMicro',
        logo: require('../assets/Super_Micro_Computer_Logo.png'),
        description: 'A leading provider of high-performance server and storage solutions optimized for enterprise data centers, cloud computing, and artificial intelligence infrastructure.'
      }   
    ]
  }),
  
  getters: {
    getProductById: (state) => (id) => {
      return state.products.find(product => product.id === parseInt(id))
    }
  }
})
